import type { CashiersChipsTransfer } from '@/generated/graphql';

import { IAdmin, mapGQLAdmin } from './admin';

export interface ICashiersChipsTransfer {
  id: string;
  amount: number;
  createdAt: string;
  updatedAt: string;

  admin: IAdmin;
}

export interface ICashiersChipsTransferTable {
  id: string;
  amount: number;
  createdAt: string;
  username: string;
}

export interface ICashiersChipsTransferQueryVariable {
  first: number;
  after?: string;
  before?: string;
}

export function mapGQLCashiersChipsTransfer(gql_cashiersChipsTransfer?: CashiersChipsTransfer | null): ICashiersChipsTransfer {
  return {
    id: gql_cashiersChipsTransfer?.id ?? '',
    amount: gql_cashiersChipsTransfer ? gql_cashiersChipsTransfer.amount ?? 0 : 0,

    updatedAt: gql_cashiersChipsTransfer ? gql_cashiersChipsTransfer.updatedAt ?? new Date().toISOString() : new Date().toISOString(),
    admin: mapGQLAdmin(gql_cashiersChipsTransfer?.admin),
    createdAt: gql_cashiersChipsTransfer
      ? new Date(gql_cashiersChipsTransfer.createdAt).toLocaleString('en-US', {
          timeZone: 'Asia/Manila',
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          hour12: true,
          minute: '2-digit',
          hour: '2-digit',
        }) ?? ''
      : '',
  };
}
